import { InertiaProps } from "@/types/app";
import { getImageUrl } from "@/utils/global";
import { usePage } from "@inertiajs/react";

const BottomNav = () => {
    const { subMenu, puntos, user } = usePage<InertiaProps>().props;

    return (
        <>
            <div
                className="menu-category-block py-5 border-t-2 border-gray-100"
                style={{
                    backgroundImage: `url(${getImageUrl("/images/patrones/fondo%20test.png")})`,
                }}
            >
                <div className="flex justify-center items-center px-4 gap-4">
                    {subMenu.map((item) => {
                        // Determinar si es el botón principal "Ver todos los menús"
                        const isPrimary = item.nombre.toLowerCase().includes("menú") ||
                            item.nombre.toLowerCase().includes("menu");

                        return (
                            <a
                                key={item.id}
                                href={window.location.origin + "/" + item.link}
                                className={`
                                    inline-flex items-center justify-center
                                    px-6 py-2.5 rounded-md font-semibold text-sm
                                    transition-all duration-300
                                    ${isPrimary
                                        ? 'bg-[#790546] text-white hover:bg-[#9a0a5a] shadow-md hover:shadow-lg hover:scale-105 border-2 border-[#790546]'
                                        : 'bg-white text-[#790546] border-2 border-[#790546] hover:bg-[#790546] hover:text-white shadow-sm hover:shadow-md'
                                    }
                                `}
                                target="_blank"
                            >
                                {item.nombre}
                            </a>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default BottomNav;
